import { __assign, __extends } from "tslib";
import * as React from 'react';
import { Label, Icon } from '@fluentui/react/lib/';
import { AppTooltipHost } from '@ms/acui-tooltip/lib/AppTooltipHost';
import { getAppLabelStatusBaseStyles, getAppLabelStatusBaseIconStyles } from '../AppLabelStatusBase';
import { checkExperiment, ribbonExperiments } from '@ms/acui-common/lib/experiments';
import { AppContext } from '@ms/acui-context/lib/AppContext';
var AppLabel = /** @class */ (function (_super) {
    __extends(AppLabel, _super);
    function AppLabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.labelRef = React.createRef();
        return _this;
    }
    AppLabel.prototype.componentDidMount = function () {
        // The only time the label should have a tooltip is when there is a custom tooltip defined
        if (this.context.setTooltipElement && this.context.updateTooltipsHidden && this.props.customTooltip) {
            this.tooltipHost = new AppTooltipHost({
                updateTooltipsHidden: this.context.updateTooltipsHidden,
                setTooltipElement: this.context.setTooltipElement,
                refElement: this.labelRef,
                controlId: this.props.id,
                controlLabel: this.props.customTooltip,
                tooltipDirection: this.props.tooltipDirection,
                performSetOnNextFrame: !!checkExperiment(this.context, ribbonExperiments.delayRenderTooltipsIsEnabled),
            });
            this.tooltipHost.registerTooltipHostActions();
        }
    };
    AppLabel.prototype.componentWillUnmount = function () {
        if (this.tooltipHost) {
            this.tooltipHost.unregisterTooltipHostActions();
        }
    };
    AppLabel.prototype.render = function () {
        var _a = this.props, label = _a.label, iconProps = _a.iconProps, forId = _a.forId, id = _a.id;
        var classNames = getAppLabelStatusBaseStyles(this.props.styles);
        return (React.createElement("div", { className: classNames.root, ref: this.labelRef },
            iconProps && React.createElement(Icon, __assign({}, iconProps, { styles: getAppLabelStatusBaseIconStyles(iconProps) })),
            React.createElement(Label, { htmlFor: forId, id: id, className: classNames.label }, label)));
    };
    // This allows us to access AppContext directly from this.context
    AppLabel.contextType = AppContext;
    return AppLabel;
}(React.PureComponent));
export { AppLabel };
//# sourceMappingURL=AppLabel.js.map